import { COLORS, hexToRGB } from '@shared/config/colors/colors';
import { baseShadowStyle } from '@shared/style/base-shadow';
import { styled } from 'goober';

export const ToolTipText = styled('div')`
    display: none;
    flex-direction: column;
    padding: 12px 16px;
    border-radius: 8px;
    background-color: ${COLORS.neutral_00};
    border: 1px solid ${COLORS.neutral_00};
    ${baseShadowStyle}
`;

export const AvatarHover = styled('div')<{ $isEditMode: boolean }>`
    position: absolute;
    display: flex;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    cursor: ${({ $isEditMode }) => $isEditMode && 'pointer'};
    flex-shrink: 0;
    transition: opacity 0.15s ease;

    ${({ $isEditMode }) =>
        $isEditMode &&
        `opacity: 0;
		    border: 0.5px solid ${hexToRGB(COLORS.black, 0.08)};
				background-color: ${hexToRGB(COLORS.neutral_80, 0.6)};`};

    &:hover {
        opacity: 1;

        ${ToolTipText} {
            display: ${({ $isEditMode }) => ($isEditMode ? 'block' : 'none')};
            width: 190px;
            position: absolute;
            bottom: -70px;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
`;
